import React, { useContext, useState } from "react";
import {
  Item,
  Button,
  Label,
  Segment,
  Table,
  Menu,
  Icon,
  Dropdown,
  Confirm,
  Container,
  Tab,
  Divider,
} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import MinorStore from "../../../app/stores/minorStore";
import { Link } from "react-router-dom";

const MinorList: React.FC = () => {
  const minorStore = useContext(MinorStore);
  const {
    projectsByDate: projectsByDate,
    deleteProject: deleteProject,
    projectRegistry,
    selectMinorTitle,
    setActiveListTab,
    activeListTab,
    submitting,
    target,
  } = minorStore;

  const [open, setOpen] = useState(false);
  const [projectId, setProjectId] = useState("");

  const worktypeList  = Array.from(projectRegistry.values()).map((project) => {
    return project["workType"];
  });
  const worktypes = worktypeList.filter(function(item, pos) {
    return worktypeList.indexOf(item) == pos;
  })
  worktypes.unshift('ALL');

  // const statusList  = Array.from(projectRegistry.values()).map((project) => {
  //   return project["status"];
  // });
  // const statuses = statusList.filter(function(item, pos) {
  //   return statusList.indexOf(item) == pos;
  // })
  // statuses.unshift('ALL');
  
  //   return (
  //   <Table celled>
  //   <Table.Header>
  //     <Table.Row>
  //       <Table.HeaderCell>Project Code</Table.HeaderCell>
  //       <Table.HeaderCell>
  //       <Dropdown text='Work Type'>
  //       <Dropdown.Menu>
  //         <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
  //         <Dropdown.Divider/>
  //       {worktypes.map((worktype) => 
  //          <Dropdown.Item
  //            name='workType'
  //            onClick={(e, { name }) =>
  //            selectMinorTitle(name, worktype)
  //           }
  //          >
  //            {worktype}
  //          </Dropdown.Item>)}
  //         </Dropdown.Menu>
  //       </Dropdown>
  //       </Table.HeaderCell>
  //       <Table.HeaderCell>
  //       <Dropdown text='Status'>
  //       <Dropdown.Menu>
  //         <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
  //         <Dropdown.Divider/>
  //       {statuses.map((status) => 
  //          <Dropdown.Item
  //            name='status'
  //            onClick={(e, { name }) =>
  //            selectMinorTitle(name, status)
  //           }
  //          >
  //            {status}
  //          </Dropdown.Item>)}
  //         </Dropdown.Menu>
  //       </Dropdown>
  //       </Table.HeaderCell>
  //       <Table.HeaderCell>Job Location</Table.HeaderCell>
  //       <Table.HeaderCell width={1}>Action</Table.HeaderCell>
  //     </Table.Row>
  //   </Table.Header>

  //   <Table.Body>
  //     {projectsByDate.map((project) => (
  //      <Table.Row key={project.id}>
  //         <Table.Cell>
  //           <strong>{project.projectCode}</strong>
  //         </Table.Cell>
  //         <Table.Cell>{project.workType}</Table.Cell>
  //         <Table.Cell>{project.status}</Table.Cell>
  //         <Table.Cell>{project.address}</Table.Cell>          
  //         <Table.Cell>
  //           <Button.Group size="mini">
  //             <Button
  //               as={Link}
  //               to={`/projectmanagement/minor/${project.id}`}
  //               size="mini"
  //               icon="zoom in"
  //               color="blue"
  //               title="View"
  //             />
  //             <Button
  //               name={project.id}
  //               size="mini"
  //               loading={target === project.id && submitting}
  //               //onClick={(e) => deleteProject(e, project.id)}
  //               onClick={() => {
  //                 setOpen(true);
  //                 setProjectId(project.id);
  //               }}
  //               icon="delete"
  //               color="red"
  //               title="Delete"
  //             />
  //             <Confirm
  //               open={open}
  //               onCancel={() => setOpen(false)}
  //               onConfirm={(e) => {
  //                 deleteProject(projectId);
  //                   setOpen(false);
  //               }}
  //               content="Are you sure you want to delete ?"
  //               confirmButton="Yes"
  //               size="mini"
  //               style={{
  //                 position: "relative",
  //                 maxHeight: "150px",
  //                 height: "auto",
  //               }}
  //             />
  //           </Button.Group>
  //         </Table.Cell>
  //       </Table.Row>
  //     ))}
  //   </Table.Body>


  // </Table> )
  const status = [
    "Received",
    "In-Progress",
    "Completed",
    "Claim Submitted",
    "Approved for Payment",
    "Payment Received",
    "Closed",
    "Onhold",
    "Cancel",
  ];

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  function convertDate(date: string) {
    var arrDate = date.split("-");
    return arrDate[2] + "/" +arrDate[1] + "/" + arrDate[0];
  } 

  let countOfReceived = 0;
  let countOfInProgress = 0;
  let countOfCompleted = 0;
  let countOfClaim = 0;
  let countOfApproved = 0;
  let countOfPayment = 0;
  let countOfClosed = 0;
  let countOfOnhold = 0;
  let countOfCancel = 0;
  projectsByDate.map(proj => {
    if (proj.status === 'Received') countOfReceived ++; 
    if (proj.status === 'In-Progress') countOfInProgress ++; 
    if (proj.status === 'Completed') countOfCompleted ++; 
    if (proj.status === 'Claim Submitted') countOfClaim ++; 
    if (proj.status === 'Approved for Payment') countOfApproved ++; 
    if (proj.status === 'Payment Received') countOfPayment ++; 
    if (proj.status === 'Closed') countOfClosed ++; 
    if (proj.status === 'Onhold') countOfOnhold ++; 
    if (proj.status === 'Cancel') countOfCancel ++; 
  })

  const panes = status.map((stat) => {
    return {
    menuItem: ( (stat === 'Received') ? <Menu.Item><strong style={{color: 'purple'}}>Received</strong><Label>{countOfReceived}</Label></Menu.Item> : 
                (stat === 'In-Progress') ? <Menu.Item><strong style={{color: 'purple'}}>In-Progress</strong><Label>{countOfInProgress}</Label></Menu.Item> : 
                (stat === 'Completed') ? <Menu.Item><strong style={{color: 'purple'}}>Completed</strong><Label>{countOfCompleted}</Label></Menu.Item> : 
                (stat === 'Claim Submitted') ? <Menu.Item><strong style={{color: 'purple'}}>Claim Submitted</strong><Label>{countOfClaim}</Label></Menu.Item> : 
                (stat === 'Approved for Payment') ? <Menu.Item><strong style={{color: 'purple'}}>Approved for Payment</strong><Label>{countOfApproved}</Label></Menu.Item> : 
                (stat === 'Payment Received') ? <Menu.Item><strong style={{color: 'purple'}}>Payment Received</strong><Label>{countOfPayment}</Label></Menu.Item> : 
                (stat === 'Closed') ? <Menu.Item><strong style={{color: 'purple'}}>Closed</strong><Label>{countOfClosed}</Label></Menu.Item> : 
                (stat === 'Onhold') ? <Menu.Item><strong style={{color: 'purple'}}>Onhold</strong><Label>{countOfOnhold}</Label></Menu.Item> : 
                (stat === 'Cancel') ? <Menu.Item><strong style={{color: 'purple'}}>Cancel</strong><Label>{countOfCancel}</Label></Menu.Item> : 
      ''),
      render: () => (
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Project Code</Table.HeaderCell>
              <Table.HeaderCell>
        <Dropdown text='Work Type'>
        <Dropdown.Menu>
          <Dropdown.Header ><span style={{color: 'grey'}}>Choose from below</span></Dropdown.Header>
          <Dropdown.Divider/>
        {worktypes.map((worktype) => 
           <Dropdown.Item
             name='workType'
             onClick={(e, { name }) =>
             selectMinorTitle(name, worktype)
            }
           >
             {worktype}
           </Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        </Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Subcon Payment</Table.HeaderCell>
              <Table.HeaderCell>Job Location</Table.HeaderCell>
              <Table.HeaderCell>Complete Date</Table.HeaderCell>
              <Table.HeaderCell width={1}>Action</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {projectsByDate.map(
              (project) => 
                project.status === stat && (
                  <Table.Row key={project.id}>
          <Table.Cell>
            <strong>{project.projectCode}</strong>
          </Table.Cell>
          <Table.Cell>{project.workType}</Table.Cell>
          <Table.Cell>{project.status}</Table.Cell>
          <Table.Cell>{project.orderNumber}</Table.Cell>
          <Table.Cell>{project.address}</Table.Cell>     
          <Table.Cell>{(project.estimatedCompletionDate !== '') && <div>
           <strong >{convertDate(project.estimatedCompletionDate)}</strong>
           <div>{getDayOfWeek(project.estimatedCompletionDate)}</div></div>}
          </Table.Cell>        
          <Table.Cell>
            <Button.Group size="mini">
              <Button
                as={Link}
                to={`/projectmanagement/minor/${project.id}`}
                size="mini"
                icon="zoom in"
                color="blue"
                title="View"
              />
              <Button
                name={project.id}
                size="mini"
                loading={target === project.id && submitting}
                //onClick={(e) => deleteProject(e, project.id)}
                onClick={() => {
                  setOpen(true);
                  setProjectId(project.id);
                }}
                icon="delete"
                color="red"
                title="Delete"
              />
              <Confirm
                open={open}
                onCancel={() => setOpen(false)}
                onConfirm={(e) => {
                  deleteProject(projectId);
                    setOpen(false);
                }}
                content="Are you sure you want to delete ?"
                confirmButton="Yes"
                size="mini"
                style={{
                  position: "relative",
                  maxHeight: "150px",
                  height: "auto",
                }}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
                )
            )}
          </Table.Body>
        </Table>
      ),
    };
  });

  return (
    <Container fluid>
      <Tab 
      panes={panes} 
      menu={{ pointing: true }} 
      onTabChange={(e, data) => setActiveListTab(Number(data.activeIndex))}
      defaultActiveIndex={activeListTab}
      />
    </Container>
  );
     
};

export default observer(MinorList);
